import EditPlayer from "@/views/players/details/editPlayer";
import PlayerSettings from "@/views/players/details/settings";
import Recruiting from "@/views/recruiting/recruiting";

interface AppRoutes {
  path: string;
  view: React.ComponentType;
  layout: string;
  permission: string;
  title: string;
}

const Routes: AppRoutes[] = [
  {
    path: "/player/edit",
    view: EditPlayer,
    layout: "app",
    permission: "user",
    title: "Edit Player"
  },
  {
    path: "/player/settings",
    view: PlayerSettings,
    layout: "app",
    permission: "user",
    title: "Player Settings"
  },
  {
    path: "/recruiting",
    view: Recruiting,
    layout: "app",
    permission: "user",
    title: "Recruiting"
  }
];

export default Routes;
